<template>
  <div>
    <div class="nc-tabs-bar">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        :class="['nc-tab', modelValue === tab.key ? 'nc-tab--active' : 'nc-tab--inactive']"
        @click="$emit('update:modelValue', tab.key)"
      >
        <span class="nc-tab__content">
          <mdicon v-if="tab.icon" :name="tab.icon" size="16" />
          {{ tab.label }}
          <span v-if="tab.badge" class="nc-tab__badge">
            {{ tab.badge }}
          </span>
        </span>
        <span v-if="modelValue === tab.key" class="nc-tab__indicator" />
      </button>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NcTabs',
  props: {
    modelValue: { type: String, required: true },
    tabs: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped>
.nc-tabs-bar {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  padding: 0 16px;
}

.nc-tab {
  position: relative;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  transition: color 0.15s;
  background: transparent;
  border: none;
  color: inherit;
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  font-family: inherit;
  cursor: pointer;
  line-height: 1.4;
}
/* Tikgebied minimaal 44px hoog (iOS HIG / WCAG 2.5.5). */
.nc-tab::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  min-width: 44px;
  min-height: 44px;
}

.nc-tab--active {
  color: #14b69a;
}

.nc-tab--inactive {
  color: #92949c;
}

.nc-tab--inactive:hover {
  color: var(--nc-text);
}

.nc-tab__content {
  display: flex;
  align-items: center;
  gap: 6px;
}

.nc-tab__badge {
  background: #14b69a;
  color: white;
  font-size: 10px;
  font-weight: 700;
  border-radius: 9999px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.nc-tab__indicator {
  position: absolute;
  bottom: 0;
  left: 8px;
  right: 8px;
  height: 2px;
  background: #14b69a;
  border-radius: 9999px;
}
</style>
